import { FrontOfficeAuthorizations } from 'shell/authorizations/front-office';
import { HeadCell } from 'shell/components/shared/table/types';
import { CertificateClient, FiltersFormCertificate, SearchType } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [FrontOfficeAuthorizations.CertificatoQuery],
  create: [],
  edit: [FrontOfficeAuthorizations.CertificatoUpdate],
  delete: [FrontOfficeAuthorizations.CertificatoDelete],
});

export const headCells: HeadCell<CertificateClient, keyof CertificateClient>[] = [
  {
    id: 'serviceNumber',
    label: 'Numero servizio',
  },
  {
    id: 'type',
    label: 'Tipo servizio',
  },
  {
    id: 'release',
    label: 'Modalità rilascio',
  },
  {
    id: 'price',
    label: 'Importo',
  },
  {
    id: 'paymentType',
    label: 'Tipo Pagamento',
  },
  {
    id: 'fiscalCode',
    label: 'Cod. fiscale Intestatario',
  },
  {
    id: 'certificateDate',
    label: 'Data rilascio',
  },
  {
    id: 'certificateTime',
    label: 'Ora rilascio',
  },
  {
    id: 'operator',
    label: 'Operatore',
  },
  {
    id: 'serviceCode',
    label: 'Servizio',
  },
  {
    id: 'ann',
    label: 'Ann',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];

export const validationSchemaCertificateFilter = yup
  .object({
    acronym: yup.string().nullable(),
    year: yup.string().nullable(),
    progressive: yup.string().nullable(),
    dateFrom: yup.date().typeError('Data non valida').nullable(),
    dateTo: yup
      .date()
      .typeError('Data non valida')
      .nullable()
      .when('dateFrom', (dateFrom, formvalidationSchema) =>
        dateFrom && dateFrom?.toString() !== 'Invalid Date'
          ? formvalidationSchema.min(dateFrom, 'La data deve essere maggiore della data Dal')
          : formvalidationSchema.nullable()
      ),
  })
  .test('', 'Controllo ricerca persona', (values) => {
    const castedValues = values as unknown as FiltersFormCertificate;

    if (castedValues.searchType === SearchType.Person) {
      const errors: Array<yup.ValidationError> = [];

      if (!castedValues?.surname && castedValues.fiscalCode) {
        return true;
      }

      if (castedValues.surname && !castedValues.fiscalCode) {
        return true;
      }

      errors.push(new yup.ValidationError('Campo obbligatorio', undefined, 'fiscalCode'));
      errors.push(new yup.ValidationError('Campo obbligatorio', undefined, 'surname'));

      if (errors?.length === 0) {
        return true;
      }

      return new yup.ValidationError(errors);
    }

    return true;
  });
// // obbligatori acronym, year e progressive o dateFrom e dateTo
// .test('acronym', 'Controllo', (values) => {
//   const castedValues = values as unknown as FiltersFormCertificate;

//   if (!castedValues.dateFrom && !castedValues.dateTo && !castedValues.acronym) {
//     return new yup.ValidationError('Campo obbligatorio', undefined, 'acronym');
//   }

//   return true;
// })
// .test('year', 'Controllo', (values) => {
//   const castedValues = values as unknown as FiltersFormCertificate;

//   if (!castedValues.dateFrom && !castedValues.dateTo && !castedValues.year) {
//     return new yup.ValidationError('Campo obbligatorio', undefined, 'year');
//   }

//   return true;
// })
// .test('progressive', 'Controllo', (values) => {
//   const castedValues = values as unknown as FiltersFormCertificate;

//   if (!castedValues.dateFrom && !castedValues.dateTo && !castedValues.progressive) {
//     return new yup.ValidationError('Campo obbligatorio', undefined, 'progressive');
//   }

//   return true;
// });
// .test('dateFrom', 'Controllo', (values) => {
//   const castedValues = values as unknown as FiltersFormCertificate;

//   if (
//     !castedValues.acronym &&
//     !castedValues.year &&
//     !castedValues.progressive &&
//     !castedValues.dateFrom
//   ) {
//     return new yup.ValidationError('Campo obbligatorio', undefined, 'dateFrom');
//   }

//   return true;
// })
// .test('dateTo', 'Controllo', (values) => {
//   const castedValues = values as unknown as FiltersFormCertificate;

//   if (
//     !castedValues.acronym &&
//     !castedValues.year &&
//     !castedValues.progressive &&
//     !castedValues.dateTo
//   ) {
//     return new yup.ValidationError('Campo obbligatorio', undefined, 'dateTo');
//   }

//   return true;
// });
